import { useCallback } from "react";

import { MessageInput, useSendMessageMutation } from "@/generated/graphql";

export function useGroupChangeRequest(assessmentId: string) {
  const [sendMessage] = useSendMessageMutation();
  return useCallback(
    (workGroupId: string, message: MessageInput, onCompleted?: () => void) => {
      return sendMessage({
        variables: {
          assessmentId,
          message,
        },
        update: (cache, { data }) => {
          if (data?.sendMessage) {
            cache.modify({
              id: `WorkGroup:${workGroupId}`,
              fields: {
                latestGroupChangeRequest(_existing) {
                  return data?.sendMessage;
                },
              },
            });
          }
        },
        onCompleted: () => {
          onCompleted?.();
        },
      });
    },
    [sendMessage, assessmentId]
  );
}
